/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CallrailRegularAi from './callrail-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CallrailRegularAi {...validProps} />;
}
SvgComponent.iconName = 'callrailRegularAi';

export const CallrailRegularAiIcon = svgIconWrapper(SvgComponent);
